module.exports = __webpack_public_path__ + "img/templeset_ua.acdffdcb.webp";